import styled from 'styled-components';
import { createGradientOrSolid } from '../../Helper/utils/utils';

export const StyledCandivoreBundle = styled.div`
    width: 100%;
    max-width: 400px;
    height: 200px;
    aspect-ratio: 1/1.31;
    position: relative;
    font-family: ${(props: any) => props.fontFamily};
    font-weight: bold;

    .container {
        width: 100%;
        height: 76.5%;
        max-height: 170px; // safari fix
        display: flex;
        flex-direction: column;
        border-top-left-radius: ${(props: any) =>
            `${props.borderRadius || 7}px`};
        border-top-right-radius: ${(props: any) =>
            `${props.borderRadius || 7}px`};
        background: ${(props: any) =>
            createGradientOrSolid(props.bundleBorderColor)};

        .product {
            height: 100%;
            display: flex;
            flex-direction: column;
            padding: 1px 1px 0 1px;
            border-top-left-radius: ${(props: any) =>
                `${props.borderRadius || 7}px`};
            border-top-right-radius: ${(props: any) =>
                `${props.borderRadius || 7}px`};
            background: ${(props: any) =>
                props.backgroundSrc
                    ? `url("${props.backgroundSrc}")`
                    : createGradientOrSolid(props.backgroundColor)};
            background-clip: content-box;
            background-size: cover;
            gap: 0px;

            .badge-wrapper {
                max-height: 18px;
                min-height: calc(15% - 4px);

                & > div {
                    top: -4px;
                }
            }

            .amount {
                height: 80%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                margin: 0 10px;
                color: ${(props: any) => props.productColor};
                text-shadow: 0px 0px 2px black;
                text-align: left;
                font-size: 20px;

                & > div {
                    display: flex;
                    align-items: center;
                }

                .stroked {
                    font-size: 11px;
                    position: relative;

                    &::after {
                        content: ' ';
                        height: 2px;
                        width: 130%;
                        background: #d8232a;
                        position: absolute;
                        left: -15%;
                        top: 50%;
                    }
                }

                img {
                    height: 14px;
                    aspect-ratio: 1/1;
                    margin: 0 4px 0 0;
                }
            }

            .image {
                height: 100%;
                display: flex;
                justify-content: center;
                overflow: hidden;
                align-items: end;
                margin: 5px;

                img {
                    max-width: 120px;
                    height: 100%;
                    width: 100%;
                    object-fit: contain;
                }
            }
        }
    }

    .price {
        height: 23.5%;
        border-bottom-left-radius: ${(props: any) =>
            `${props.borderRadius || 7}px`};
        border-bottom-right-radius: ${(props: any) =>
            `${props.borderRadius || 7}px`};
        border-bottom: 4px solid rgba(56, 127, 34, 1);
        box-shadow: 0px -2px 4px -2px rgba(255, 255, 255, 0.8) inset;
    }

    @media (max-width: 500px) {
        height: 148px;

        .image {
            img {
                max-width: 100px;
            }
        }
    }

    @media (max-width: 350px) {
        .product .amount {
            font-size: 10px;

            img {
                height: 12px;
            }
        }
    }
    @media (min-width: 450px) {
        .container .product .amount {
            font-size: 18px;

            .image {
                min-height: 80px;

                img {
                    height: 18px;
                }
            }
        }
    }
` as any;
